import { render } from "./hero.vue?vue&type=template&id=3760ed04&scoped=true"
const script = {}

import "./hero.vue?vue&type=style&index=0&id=3760ed04&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\zoinix-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3760ed04"]])

export default __exports__